import Page from './Page';
import Component from 'vue-class-component';

import TabBar from './TabBar.vue';
import HeaderComponent from './Header.vue';
import template from './LockstateQr.vue.html';

type ReservesRoom = {
    id: number;
    start_time: string;
    end_time: string;
    name: string | Translation;
    ssid: string | null;
    wifi_password: string | null;
    lockstate_pin: string;
    lockstate_qr: string;
};
@Component({ template, components: { TabBar, HeaderComponent } })
export default class LockstateQr extends Page {}
